// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cMdk","toggle":"styles_toggle__1v3TG","preview":"styles_preview__2ySIs"};